export default "__VITE_ASSET__D_B6GJrM__"